import { createContext } from 'react';

export const SignUpContext = createContext({} as any);
